import React from 'react';
import PortfolioUserCard from 'components/PortfolioUserCard';

const PropertyUsersSection = ({ users, isLoading, error, onUserClick }) => {
	if (isLoading) {
		return (
			<div className="property-section-card">
				<div className="property-section-header">
					<h5>
						<i className="bi bi-people" />
						Users (0)
					</h5>
				</div>
				<div className="property-section-body">
					<div className="loading-state">
						<div className="spinner-border" role="status">
							<span className="visually-hidden">Loading users...</span>
						</div>
					</div>
				</div>
			</div>
		);
	}

	return (
		<>
			<div className="users-grid">
				{users?.map((user) => (
					<PortfolioUserCard
						key={user.id}
						user={user}
						onClick={() => onUserClick(user)}
					/>
				))}
			</div>
		</>
	);
};

export default PropertyUsersSection;
